import {
  GetCandidateSmartInterviewsVideosInput,
  GetCandidateSmartInterviewsVideosOutput,
  SmartInterviewsBuilder,
} from '../smart-interviews.types';

export const getCandidateSmartInterviewsVideos = (
  builder: SmartInterviewsBuilder
) =>
  builder.query<
    GetCandidateSmartInterviewsVideosOutput,
    GetCandidateSmartInterviewsVideosInput
  >({
    query: ({ candidateId, status }) => ({
      url: `/candidates/${candidateId}/smart-interviews`,
      params: { status },
      method: 'GET',
    }),
    providesTags: () => [{ type: 'SmartInterviewsVideos' }],
  });
